import IMCategoriesPromotionList from './IMCategoriesPromotionList';

export default IMCategoriesPromotionList;
